import { Box, Chip, Divider, Stack, Typography } from "@mui/material";
import AppButton from "../../components/AppButton";
import StarIcon from "@mui/icons-material/Star";
import { FormattedMessage } from "react-intl";

import { Candidate } from "./types";

type Props = {
  candidate: Candidate;
  /** Already tracked, or the property is at its allowance. */
  disabled: boolean;
  disabledReason?: string;
  onAdd: (candidate: Candidate) => void;
  adding: boolean;
};

/** The panel shown when a candidate pin is clicked. */
const CompetitorCard = ({
  candidate,
  disabled,
  disabledReason,
  onAdd,
  adding,
}: Props) => (
  <Stack spacing={1} sx={{ p: 2, minWidth: 260, maxWidth: 320 }}>
    <Typography variant="subtitle1">{candidate.name}</Typography>

    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: "center", flexWrap: "wrap" }}
    >
      {candidate.stars !== null && (
        <Chip
          size="small"
          icon={<StarIcon fontSize="small" />}
          label={candidate.stars}
        />
      )}
      {candidate.rating !== null && (
        <Chip
          size="small"
          label={
            candidate.reviewsCount
              ? `${candidate.rating} (${candidate.reviewsCount})`
              : `${candidate.rating}`
          }
        />
      )}
      <Chip size="small" label={`${candidate.distanceKm.toFixed(1)} km`} />
    </Stack>

    {candidate.city && (
      <Typography variant="caption" color="text.secondary">
        {candidate.city}
      </Typography>
    )}

    <Divider />

    <Box>
      <AppButton
        fullWidth
        size="small"
        disabled={disabled || adding}
        onClick={() => onAdd(candidate)}
      >
        <FormattedMessage id="COMPETITOR_SELECTION_ADD" />
      </AppButton>
      {disabled && disabledReason && (
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 1, color: "text.secondary" }}
        >
          {disabledReason}
        </Typography>
      )}
    </Box>
  </Stack>
);

export default CompetitorCard;
